type ExtractResult = {
  content: string;
  hasQuotedContent: boolean;
};

const ORIGINAL_MESSAGE_PATTERNS = [
  'Original Message',
  "Message d'origine",
  'Oorspronkelijk bericht',
];

export function extractMainMailContent(emailBody: string): ExtractResult {
  const parser = new DOMParser();
  const doc = parser.parseFromString(emailBody, 'text/html');

  let hasQuotedContent = false;

  // Gmail: remove .gmail_quote elements
  doc.querySelectorAll('.gmail_quote').forEach(el => {
    hasQuotedContent = true;
    el.remove();
  });

  // Gmail: remove blockquote elements
  doc.querySelectorAll('blockquote').forEach(el => {
    hasQuotedContent = true;
    el.remove();
  });

  // Microsoft: remove everything after "Original Message" separator (EN, FR, NL)
  const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  let separatorFound: { node: Text; index: number } | null = null;

  for (
    let node = walker.nextNode() as Text | null;
    node !== null;
    node = walker.nextNode() as Text | null
  ) {
    const text = node.textContent || '';
    // Find the earliest matching separator within this text node. Plain-text
    // emails are a single text node, so the separator sits mid-node, not as
    // its own element.
    const separatorIndex = ORIGINAL_MESSAGE_PATTERNS.reduce((earliest, pattern) => {
      const patternIndex = text.indexOf(pattern);
      if (patternIndex === -1) return earliest;
      return earliest === -1 ? patternIndex : Math.min(earliest, patternIndex);
    }, -1);
    if (separatorIndex !== -1) {
      separatorFound = { node, index: separatorIndex };
      break;
    }
  }

  if (separatorFound) {
    hasQuotedContent = true;
    const { node, index } = separatorFound;
    // Keep only the text before the separator inside the matched node (handles
    // plain-text emails where the whole body is a single text node).
    node.textContent = (node.textContent || '').slice(0, index);
    // Remove everything after the separator by stripping following siblings
    // while walking up the tree. Stop at doc.body so the body element is never
    // removed (removing it would null out doc.body and crash below).
    let current: Node | null = node;
    while (current && current !== doc.body) {
      while (current.nextSibling) {
        current.nextSibling.remove();
      }
      current = current.parentNode;
    }
  }

  return {
    content: doc.body.innerHTML.trim(),
    hasQuotedContent,
  };
}
